import { render, staticRenderFns } from "./ResourceConstruction.vue?vue&type=template&id=0baa71e2&scoped=true"
import script from "./ResourceConstruction.vue?vue&type=script&lang=js"
export * from "./ResourceConstruction.vue?vue&type=script&lang=js"
import style0 from "./ResourceConstruction.vue?vue&type=style&index=0&id=0baa71e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa71e2",
  null
  
)

export default component.exports